<template>
    <b-card id="card-collapse" no-body :border-variant="border" class="mb-2">
        <b-card-header header-tag="header" role="tab">
            <div>
                <h6 class="my-auto text-left" v-b-toggle="myId">
                    <font-awesome-icon :icon="cardVisivel ? 'chevron-up' : 'chevron-down'" class="mr-2" />
                    {{ titulo }}
                </h6>
            </div>
        </b-card-header>
        <b-collapse :id="myId" visible v-model="cardVisivel">
            <b-card-body>
                <slot></slot>
            </b-card-body>
        </b-collapse>
    </b-card>
</template>

<script>
import { RandomId } from '@/mixins/random-id.mixin'

export default {
    name: 'CardCollapse',
    mixins: [RandomId],
    data() {
        return {
            cardVisivel: true,
            myId: null,
        }
    },
    props: {
        titulo: {
            type: String,
            default: ''
        },
        border: {
            type: String,
            default: ''
        },
    },
    created() {
        this.myId = this.generateId()
    },
}
</script>

<style scoped></style>